import React from 'react';
import { useNavigate } from 'react-router-dom';
import Path from 'app/route/Path';
import { formatDate } from 'app/utils';
import GA, { EVENT_NAMES } from 'app/services/googleAnalytics';
import { CATEGORY_OPTIONS, MENU_CATEGORY_OPTIONS } from 'app/services/api/fake_services/menu_management_fake_data';

export default function MenuCard({
  id,
  code,
  name,
  category,
  treatmentTime,
  publicStatus,
  updatedAt,
  onDelete,
  onCopy,
}) {
  const navigate = useNavigate();

  const handleOpenInNewWindow = () => {
    GA.tracking(EVENT_NAMES.MENU_LIST?.CLICK_DETAIL, { menuId: id });
    const url = Path.menuManagementDetail(id);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleEdit = () => {
    GA.tracking(EVENT_NAMES.MENU_LIST?.CLICK_UPDATE, { menuId: id });
    navigate(Path.menuManagementEdit(id));
  };

  const getCategoryName = (menuType) => {
    return [...CATEGORY_OPTIONS, ...MENU_CATEGORY_OPTIONS].find((option) => option.id === menuType)?.label || menuType;
  };

  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-4 shadow-sm">
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span
              className={`px-2 py-0.5 rounded text-[10px] font-bold ${publicStatus ? 'text-blue-btn-primary border border-blue-100' : 'bg-slate-100 text-slate-500 border border-slate-200'}`}
            >
              {publicStatus ? '公開中' : '非公開'}
            </span>
            <span className="text-[11px] text-slate-400">{`ID: ${code}`}</span>
          </div>
          <h3 className="font-bold text-slate-900 leading-snug break-all">{name}</h3>
        </div>
        <div className="flex gap-1">
          <button
            onClick={handleOpenInNewWindow}
            className="p-2 text-slate-400 hover:text-primary active:bg-slate-50 rounded-lg"
          >
            <span className="material-symbols-outlined text-xl">open_in_new</span>
          </button>
          <button onClick={handleEdit} className="p-2 text-slate-400 hover:text-primary active:bg-slate-50 rounded-lg">
            <span className="material-symbols-outlined text-xl">edit</span>
          </button>
          <button onClick={onCopy} className="p-2 text-slate-400 hover:text-slate-600 active:bg-slate-50 rounded-lg">
            <span className="material-symbols-outlined text-xl">content_copy</span>
          </button>
          <button onClick={onDelete} className="p-2 text-slate-400 hover:text-red-500 active:bg-red-50 rounded-lg">
            <span className="material-symbols-outlined text-xl">delete</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-y-2 pt-3 border-t border-slate-50">
        <div>
          <p className="text-[10px] text-slate-400 uppercase tracking-wider font-bold mb-0.5">カテゴリ</p>
          <p className="text-sm text-slate-700">{category ? getCategoryName(category) : '-'}</p>
        </div>
        <div>
          <p className="text-[10px] text-slate-400 uppercase tracking-wider font-bold mb-0.5">施術時間</p>
          <p className="text-sm text-slate-700">{treatmentTime ? `${treatmentTime}分` : '-'}</p>
        </div>
        <div className="col-span-2">
          <p className="text-[10px] text-slate-400 uppercase tracking-wider font-bold mb-0.5">最終更新日</p>
          <p className="text-sm text-slate-700">{formatDate(updatedAt)}</p>
        </div>
      </div>
    </div>
  );
}
